import { render, staticRenderFns } from "./uploadmatter.vue?vue&type=template&id=6b6e4f4e&scoped=true&"
import script from "./uploadmatter.vue?vue&type=script&lang=js&"
export * from "./uploadmatter.vue?vue&type=script&lang=js&"
import style0 from "./uploadmatter.vue?vue&type=style&index=0&id=6b6e4f4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e4f4e",
  null
  
)

export default component.exports